module.exports = __webpack_public_path__ + "media/icons/default_pfp-dbf79c59.svg";